<div class="container mx-auto p-6">
  <div *ngIf="loading" class="flex justify-center items-center h-64">
    <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
  </div>

  <div *ngIf="!loading && movement" class="bg-white rounded-lg shadow-lg p-6">
    <div class="mb-6 flex justify-between items-start">
      <div>
        <h2 class="text-2xl font-bold text-gray-800">Detalles del Movimiento</h2>
        <p class="text-gray-600">ID: #{{ movement.id }}</p>
      </div>
      <button
        [routerLink]="['/dashboard/administracion']"
        [queryParams]="{entity: 'movements'}"
        class="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors">
        Volver a Movimientos
      </button>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
      <!-- Tipo de Movimiento -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Tipo de Movimiento</label>
        <p [class]="getTypeColor(movement.type)" class="text-lg font-semibold">
          {{ getTypeLabel(movement.type) }}
        </p>
      </div>

      <!-- Monto -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Monto</label>
        <p class="text-lg font-semibold text-gray-900">
          {{ movement.amount | currency:'EUR':'symbol':'1.2-2' }}
        </p>
      </div>

      <!-- Banco -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Banco</label>
        <p class="text-gray-900">{{ movement.bank?.name || 'N/A' }}</p>
      </div>

      <!-- Banco Destino (solo para transferencias) -->
      <div *ngIf="movement.type === 'transfer'" class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Banco Destino</label>
        <p class="text-gray-900">{{ movement.destination_bank?.name || 'N/A' }}</p>
      </div>

      <!-- Fecha -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha del Movimiento</label>
        <p class="text-gray-900">{{ movement.movement_date | date:'dd/MM/yyyy' }}</p>
      </div>

      <!-- Número de Referencia -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Número de Referencia</label>
        <p class="text-gray-900">{{ movement.reference_number || 'N/A' }}</p>
      </div>

      <!-- Concepto -->
      <div class="border-b pb-4 md:col-span-2">
        <label class="block text-sm font-medium text-gray-700 mb-1">Concepto</label>
        <p class="text-gray-900">{{ movement.concept }}</p>
      </div>

      <!-- Cuenta Contable -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Cuenta Contable</label>
        <p class="text-gray-900">{{ movement.account_chart?.name || 'N/A' }}</p>
      </div>

      <!-- Estado -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Estado</label>
        <span *ngIf="movement.locked" class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-red-100 text-red-800">
          🔒 Bloqueado
        </span>
        <span *ngIf="!movement.locked" class="inline-flex items-center px-3 py-1 rounded-full text-sm font-medium bg-green-100 text-green-800">
          ✓ Editable
        </span>
      </div>

      <!-- Usuario que creó -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Creado por</label>
        <p class="text-gray-900">{{ movement.created_by_user?.name || 'N/A' }}</p>
      </div>

      <!-- Fecha de Creación -->
      <div class="border-b pb-4">
        <label class="block text-sm font-medium text-gray-700 mb-1">Fecha de Creación</label>
        <p class="text-gray-900">{{ movement.created_at | date:'dd/MM/yyyy HH:mm' }}</p>
      </div>
    </div>
  </div>

  <div *ngIf="!loading && !movement" class="text-center py-12">
    <p class="text-gray-500 text-lg">Movimiento no encontrado</p>
  </div>
</div>
